import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["href", "children"],
    _excluded2 = ["href", "children", "ref"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Link from 'next/link';
import { isDev } from '@restworld/utils-common';
import { Link as CustomLink } from '../../design-system/link';
import { jsx as _jsx } from "react/jsx-runtime";
export var V2Link = function V2Link(_ref) {
  var href = _ref.href,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var newHref = typeof href === 'string' ? "/v2".concat(href) : _objectSpread(_objectSpread({}, href), {}, {
    pathname: "/v2".concat(href.pathname)
  });
  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
    href: isDev ? href : newHref
  }, rest), {}, {
    children: children
  }));
};
export default V2Link;
export var V2CustomLink = function V2CustomLink(_ref2) {
  var href = _ref2.href,
      children = _ref2.children,
      ref = _ref2.ref,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var newHref = "/v2".concat(href);
  return /*#__PURE__*/_jsx(CustomLink, _objectSpread(_objectSpread({
    href: isDev ? href : newHref
  }, rest), {}, {
    children: children
  }));
};